module.exports = __webpack_public_path__ + "img/logo-fleurop.9f01c342.svg";